const chartId = "chart-15b"
let Chart = require('chart.js');
Chart.defaults.global.defaultFontFamily = 'acumin-pro';

const _groupBy = require('lodash/groupBy')
const _each = require('lodash/each')
const _sortBy = require('lodash/sortBy')

const data = require('./data');
const config = require('../../../config');
const full = config.colorHues.full; //full colors
const eighty = config.colorHues.eighty; //80% colors

const sortedData = _sortBy(data, "Race")
const groupedData = _groupBy(sortedData, "Race");

let datasets = [];
let i = 0;
let labels = Array.from({ length: 40 }, function() {
  i++;
  return (54 + i).toString();
})

i = 0;
_each(groupedData, function(group) {
  const obj = {
    label: group[0].Race,
    data: [],
    backgroundColor: eighty[i],
    borderColor: full[i],
    borderWidth: 1,
  }
  _each(group, function(row) {
    obj.data.push({
      x: row.Age,
      y: row.Count
    })
  })
  datasets.push(obj)
  i++;
})

labels = [...new Set(labels)]

let ctx = document.getElementById(chartId).getContext('2d');
var barChartData = {
  labels: labels,
  datasets: datasets
};

new Chart(ctx, {
  type: 'bar',
  data: barChartData,
  options: {
    title: {
      display: false
    },
    tooltips: {
      mode: 'index',
      intersect: false
    },
    responsive: true,
    aspectRatio: window.innerWidth > 992 ? 16 / 9 : 1,
    onResize: function(chartObj) {
      chartObj.aspectRatio = window.innerWidth > 992 ? 16 / 9 : 1;
      chartObj.update()
    },
    scales: {
      xAxes: [{
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: 'Life Expectancy'
        }
      }],
      yAxes: [{
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: 'Number of tracts'
        }
      }]
    }
  }
});